<template>
  <b-row>
    <b-col sm="2"></b-col>
    <b-col sm="6">{{ id }}. <label for="rating-10">{{ name }}:</label>
    </b-col>
    <b-col sm="4">
      <b-form-rating
          id="rating-10"
          v-model="varRating"
          inline
          no-border
          size="lg"
          stars="5"
          variant="warning"
          @change="handleInput"
      ></b-form-rating>
      <b-badge
          v-if="varRating == 1"
          variant="danger"
      >{{
          $t("public.components.xray.rating.rateVeryBad")
        }}
      </b-badge>
      <b-badge
          v-if="varRating == 2"
          variant="dark"
      >{{
          $t("public.components.xray.rating.rateBad")
        }}
      </b-badge>
      <b-badge
          v-if="varRating == 3"
          variant="warning"
      >{{
          $t("public.components.xray.rating.rateNormal")
        }}
      </b-badge>
      <b-badge
          v-if="varRating == 4"
          variant="info"
      >{{
          $t("public.components.xray.rating.rateGood")
        }}
      </b-badge>
      <b-badge
          v-if="varRating == 5"
          variant="success"
      >{{
          $t("public.components.xray.rating.rateVeryGood")
        }}
      </b-badge>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: "RatingForm",
  props: {
    name: {type: String, required: true},
    id: {type: Number, required: true},
  },
  methods: {
    handleInput(e) {
      let object = {question: this.name, value: e};
      this.$emit("input", object);
    },
  },
  data() {
    return {
      varRating: null,
    };
  },
};
</script>
